import {
  CDW_EDUCATION_PRIVACY_URL,
  GOPHER_MARKETING_URL,
  GOPHER_SUPPORT_EMAIL,
  GOPHER_SUPPORT_MAILTO,
} from '@cdw-ae/common-data';

/**
 * Shared URLs used across all environments.
 * These URLs remain constant regardless of deployment environment.
 */
export const sharedUrls = {
  support: {
    helpCenter: 'https://amplifiedlabs.zendesk.com/hc/en-us',
    /** "Contact Support" — the nav accordion and the concurrency modal (US-12). */
    contactSupport: GOPHER_SUPPORT_MAILTO,
    /**
     * "Start Renewal Process" — the lapsed-subscription screen's only CTA
     * (EDUS-2810). Neither the Figma frame nor the ticket says where this
     * button goes, and design confirmed 2026-09-24 that they don't know
     * either, which made it a product question. **Decided 2026-09-24
     * (Anthony): this mailto is the answer, not a placeholder.** The better
     * destination in theory is the customer's own CDW account rep, but we hold
     * no data to construct that link — routing through support is the only
     * route that reaches a human who can look the rep up. The renewal-specific
     * subject (rather than reusing `contactSupport` above) is what lets them
     * triage it. Revisit only if product asks; nothing else depends on this.
     */
    renewalRequest: `mailto:${GOPHER_SUPPORT_EMAIL}?subject=Gopher%20for%20Chrome%20Premium%20Renewal%20Request`,
    articles: {
      accessManagement:
        'https://amplifiedlabs.zendesk.com/hc/en-us/articles/44817526592659-Understanding-and-Utilizing-Access-Management',
      deviceActionEligibility:
        'https://amplifiedlabs.zendesk.com/hc/en-us/articles/51106328979091-Understanding-Device-Action-Eligibility-and-State-Rules',
      gopherBuddySetup:
        'https://amplifiedlabs.zendesk.com/hc/en-us/articles/360002516793-Install-and-Setup-Gopher-Buddy-Gopher-Buddy-Settings',
      // Onboarding Step 3 "Authorize Scopes" learn-more link (FR-4.1, EDUS-2684).
      dwdExplained:
        'https://amplifiedlabs.zendesk.com/hc/en-us/articles/45408319244947-Domain-Wide-Delegation-DWD-Explained-for-Super-Administrators',
    },
  },
  marketing: {
    allLabsTools: 'https://www.amplifiedit.com/all-labs-tools',
    labsSite: 'https://labs.amplifiedit.com',
    /**
     * The CDW Gopher product page — where an unlicensed prospect is sent to
     * start a trial conversation (EDUS-2689 / FR-1.3 Case B). SPOG is read-only
     * against Chargify and never creates trials itself; support does, and this
     * page is how the customer reaches them.
     *
     * Shared with the backend's emails via common-data, which is also where
     * the `cm_mmc` campaign-code warning lives.
     */
    gopherProductPage: GOPHER_MARKETING_URL,
  },
  legal: {
    /**
     * The one legal document the product links to, everywhere: the sign-in
     * page, the app footer, and the Step 1 card whose acceptance we version and
     * log (`CURRENT_AGREEMENT_VERSIONS.terms`, EDUS-2681).
     *
     * Product settled this on EDUS-2849: every legal link reads "Privacy
     * Policy" and points here. There is no terms-of-service document — the
     * separate `termsAndConditions` constant (same URL) and the sign-in page's
     * Amplified IT "Terms of service" link were both removed rather than left
     * as a second label for one document.
     */
    privacyNotice: CDW_EDUCATION_PRIVACY_URL,
  },
};
